import React, {useState} from "react";
import Banner from "./Banner/Banner";
import LiveAuctions from "./LiveAuctions/LiveAuctions";
import NavLayout from "../../GlobalComponents/NavLayout/NavLayout";
import { common, publicNav } from "../../utils/navItems";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import Banner2 from "../NftAuction/Banner/Banner";
import nextImg from "./assets/chevron-right.png";
import preImg from "./assets/chevron-left.png";
import TheNfts from "../NftAuction/TheNfts/TheNfts";
import UsingTheNFT from "./UsingTheNFT/UsingTheNFT";
import HowToBuy from "./HowToBuy/HowToBuy";
import Footer from "../../GlobalComponents/Footer/Footer";
import ConnectButton from "../../GlobalComponents/ConnectButton/ConnectButton";
const Marketplace = () => {
  const [address, setAddress] = useState("");
  return (
    <div>
      <NavLayout
        navItems={publicNav}
        bold={true}
        setAddress={setAddress}
        buttons={
          <div className="button-container">
            <button className=" w-[120px] h-10 border font-normal text-res-xs leading-[19px] border-solid border-main-green">
              <span>R34P</span>
              <span className="font-black"> $36.65</span>
            </button>
            <ConnectButton></ConnectButton>
          </div>
        }
      ></NavLayout>

      <div className="relative">
        <Swiper
          slidesPerView={1}
          navigation={{
            nextEl: ".image-swiper-button-next1",
            prevEl: ".image-swiper-button-prev1",
            disabledClass: "swiper-button-disabled",
          }}
          loop={true}
          pagination={{
            clickable: true,
          }}
          modules={[Navigation]}
          className="mySwiper"
        >
          <SwiperSlide>
            <Banner></Banner>
          </SwiperSlide>
          <SwiperSlide>
            <Banner2></Banner2>
          </SwiperSlide>
        </Swiper>
        <div className="image-swiper-button-prev1 absolute left-0 2xl:left-[14%] top-[39%] flex justify-center items-center bg-main-black w-[44px] h-[44px] rounded-[8px] z-10 cursor-pointer select-none">
          <img src={preImg} alt="" />
        </div>
        <div className="image-swiper-button-next1 absolute right-0 2xl:right-[14%] top-[39%]  flex justify-center items-center bg-main-black w-[44px] h-[44px] rounded-[8px] z-10 cursor-pointer select-none">
          <img src={nextImg} alt="" />
        </div>
      </div>
      <LiveAuctions></LiveAuctions>
      <TheNfts></TheNfts>
      <UsingTheNFT></UsingTheNFT>
      <HowToBuy></HowToBuy>
      <div className="mt-10">
        <Footer></Footer>
      </div>
    </div>
  );
};

export default Marketplace;
